import * as React from "react";
import { API } from "../API";
import { NotificationScreen } from "../components/NotificationScreen";
import { isLoading } from "../Loading";
import { VisitBroadcastId } from "../messages/ObjectIds";
import { OnboardingCaregiversNotificationPayloads } from "../messages/OnboardingCaregiversWorker";
import { NotificationType, PushNotificationInfo } from "../messages/PushNotificationMessages";
import { AppState } from "../system/AppState";
import { ActivityStateMixin, ActivityStateMixinState } from "./ActivityStateMixin";

interface NotificationActivityProps {
  appState: AppState;
  api: API;
  onBackClick: () => void;
  onVisitNotificationClick: (visitId: VisitBroadcastId) => void;
  onOnboardingEngagementNotificationClick: (
    payload: OnboardingCaregiversNotificationPayloads[keyof OnboardingCaregiversNotificationPayloads]
  ) => void;
  onGeneralVisitAssignmentNotificationClick: () => void;
}

interface NotificationActivityState {
  mixin: ActivityStateMixinState;
}

export class NotificationActivity extends React.Component<
  NotificationActivityProps,
  NotificationActivityState
> {
  constructor(props: NotificationActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: NotificationActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      mixin: this.activityStateMixin.initialState(),
    };
  }

  private activityStateMixin: ActivityStateMixin;

  componentWillUnmount() {
    this.activityStateMixin.componentWillUnmount();
  }

  handleNotificationClick = (notification: PushNotificationInfo): void => {
    switch (notification.pushNotification.type) {
      case NotificationType.VISIT_NOTIFICATION:
        this.props.onVisitNotificationClick(notification.pushNotification.visitId);
        this.props.api.setNotificationClicked(notification.id);
        break;
      case NotificationType.ONBOARDING_CAREGIVER_ENGAGEMENTS2:
        this.props.onOnboardingEngagementNotificationClick(notification.pushNotification.payload);
        this.props.api.setNotificationClicked(notification.id);
        break;
      case NotificationType.GENERAL_VISIT_ASSIGNMENT_NOTIFICATION:
        this.props.onGeneralVisitAssignmentNotificationClick();
        this.props.api.setNotificationClicked(notification.id);
        break;
      default:
    }
    this.state.mixin.notificationsState.setNotificationClicked(notification.id);
  };

  handleNotificationsViewed = (): void => {
    this.props.api.setNotificationsViewed();
    this.state.mixin.notificationsState.setNotificationsViewed();
  };

  render() {
    const notifications = this.state.mixin.notificationsState
      .getNotificationsDB()
      .getNotifications();
    let relevantNotifications = null;

    if (isLoading(this.state.mixin.appVisitsState)) {
      relevantNotifications = notifications.pushNotificationInfos;
    } else {
      const visits = this.state.mixin.appVisitsState.visits;
      relevantNotifications = notifications.pushNotificationInfos.filter((notification) => {
        if (notification.pushNotification.type === "VISIT_NOTIFICATION") {
          const visitId = notification.pushNotification.visitId;
          return visits.some((visit) => visit.publicVisitBroadcastDetails.id === visitId);
        }
        return true;
      });
    }
    return (
      <NotificationScreen
        pushNotificationInfoList={relevantNotifications}
        onNotificationClick={this.handleNotificationClick}
        onBackClick={this.props.onBackClick}
        onNotificationsViewed={this.handleNotificationsViewed}
      />
    );
  }
}
